import type { Status } from '../types/Status';

export const getStatusLiveRole = (status: Status): 'alert' | 'status' =>
  status === 'critical' || status === 'cautious' ? 'alert' : 'status';
